import { useContext, useState } from "react";
import { RootContext } from "../../../../stores";
import { IAdminInvitationFlowValues } from "../_interfaces/IAdminInvitationFlowValues";
import { ILogoutRequiredFormValues } from "../../../authentication/_interfaces/ILogoutRequiredFormValues";

export function useLogoutRequiredController(
    values: ILogoutRequiredFormValues,
    allValues: IAdminInvitationFlowValues,
    update: (patch: Partial<ILogoutRequiredFormValues>) => void,
    onSuccess: (override?: Partial<ILogoutRequiredFormValues>) => void
) {
    const rootStore = useContext(RootContext);

    const [error, setError] = useState<string>();
    const [fieldErrors, setFieldErrors] = useState<Partial<Record<keyof ILogoutRequiredFormValues, string>>>({});
    const [isSubmitting, setSubmitting] = useState(false);
    const [validationRun, setValidationRun] = useState(false);

    const submit = async (override?: Partial<ILogoutRequiredFormValues>) => {
        setSubmitting(true);
        setError(undefined);
        setValidationRun(true);

        try {
            const result = await rootStore.userStore.logout();
            update({ loggedOut: true });
        } catch {
            setError("Error logging out");
        } finally {
            setSubmitting(false);
        }
    };

    return {
        values,
        onChange: update,
        onSubmit: submit,
        isSubmitting,
        error,
        fieldErrors
    };
}
